import { createSlice } from "@reduxjs/toolkit";
import { FilterStateStoreEmail } from "./types";

const INITIAL_STATE: FilterStateStoreEmail = {
  filters: {
    search: "",
    order: {},
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const storeEmailFilterSlice = createSlice({
  name: "storeEmailFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setStoreEmailFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setStoreEmailFilter } = storeEmailFilterSlice.actions;
export default storeEmailFilterSlice.reducer;
